import { Accordion, AccordionSummary, Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { MuiAccordionOverride, MuiAccordionSummaryOverride, MuiCoverImagesVariantButton } from 'theme/overrides';
var VariantAccordion = withStyles(MuiAccordionOverride)(Accordion);
var VariantAccordionSummary = withStyles(MuiAccordionSummaryOverride)(AccordionSummary);
var VariantButton = withStyles(MuiCoverImagesVariantButton)(Button);
export { VariantAccordion, VariantAccordionSummary, VariantButton };